<template>
  <base-input :rules="internalRules" :errors="errors">
    <div
      :class="[
        'tw-relative tw-border tw-rounded-md focus-within:tw-ring-1 tw-ring-0 tw-flex tw-items-center tw-transition-all tw-ease-in-out tw-duration-100 tw-bg-white tw-mt-1',
        `focus-within:tw-ring-${focusColor} focus-within:tw-border-${focusColor} tw-border-${borderColor}`,
      ]"
    >
      <label
        :class="['tw-absolute tw--top-2 tw-left-2 tw--mt-px tw-z-40 tw-inline-block tw-px-1 tw-bg-white tw-text-xs tw-font-normal tw-rounded-md', `tw-text-${labelColor}`]"
        v-if="label"
        >{{ label }}</label
      >
      <v-select
        :value="value"
        :multiple="multiple"
        :options="options"
        :close-on-select="!multiple"
        @input="handleInput($event)"
        :label="labelKey"
        :placeholder="placeholder"
        :class="[
          'form-select tw-border-none tw-mt-0.5 tw-mb-0 tw-pl-3 tw-block tw-w-full tw-py-px tw-text-light focus:tw-outline-none tw-ring-0 tw-rounded-md tw-transition-all tw-ease-in-out tw-duration-100 tw-font-light tw-bg-white',
          `sm:tw-text-${size}`,
        ]"
        :selectable="(option) => (allowGroupSelection ? true : !option.isHeader)"
        @blur="validate"
      >
        <template #option="option">
          <slot name="option" :option="option">
            <div v-if="option.isHeader" class="tw-text-xs tw-z-50 tw-font-medium tw-text-gray-500">{{ option[labelKey] }}</div>
            <div v-else class="">{{ option[labelKey] }}</div>
          </slot>
        </template>
        <template #selected-option-container="{ option, deselect, multiple, disabled }">
          <slot name="selected-option" :option="option" :deselect="deselect" :multiple="multiple" :disabled="disabled">
            <div class="tw-flex tw-items-center tw-z-50 tw-rounded-full tw-mr-1 tw-py-1 tw-px-3 tw-bg-primary-50 tw-text-primary-600 tw-mt-0.5" v-if="multiple">
              {{ option[labelKey] }}
              <div @click="deselect(option)">
                <x-icon class="tw-h-3 tw-w-3 tw-ml-1.5 tw-z-50 tw-cursor-pointer" />
              </div>
            </div>
            <div class="tw-flex tw-items-center tw-text-black tw-z-50" v-else>
              {{ option[labelKey] }}
            </div>
          </slot>
        </template>
        <template #search="{ attributes, events }">
          <input
            :class="[
              'advance-form-select form-input tw-z-50 tw-flex-grow tw-block tw-border-0 tw-p-0 tw-mt-px tw-text-gray-900 focus:tw-ring-0 tw-font-light',
              `tw-placeholder-${placeholderColor} sm:tw-text-${size}`,
            ]"
            v-bind="attributes"
            v-on="events"
            @blur="validate"
          />
        </template>
        <template #no-options>
          <div class="tw-py-3 tw-text-gray-500 tw-z-50">
            No results
          </div>
        </template>
      </v-select>
    </div>
  </base-input>
</template>

<script>
import vSelect from "vue-select";
import { XIcon } from "@/assets/svgs";
import validatable from "@/mixins/validatable";

export default {
  mixins: [validatable],
  components: {
    vSelect,
    XIcon,
  },
  props: {
    value: [Array, String, Object],
    label: String,
    placeholder: String,
    multiple: Boolean,
    options: Array,
    labelKey: {
      type: String,
      default: "label",
    },
    size: {
      type: String,
      default: "sm",
    },
    allowGroupSelection: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    focusColor() {
      return this.hasError ? "red-500" : "primary-500";
    },
    borderColor() {
      return this.hasError ? "red-500" : "gray-200";
    },
    labelColor() {
      return this.hasError ? "red-500" : "gray-900";
    },
    placeholderColor() {
      return this.hasError ? "red-400" : "gray-500";
    },
  },
  methods: {
    handleInput(event) {
      if (!this.allowGroupSelection) {
        this.validate();
        this.$emit("input", event);
        return;
      }

      //Logic for group selection
      let selectedOptions = [];
      event.forEach((option) => {
        if (option.isHeader) {
          selectedOptions.push(
            ...this.options.filter((o) => o.typeGroup === (option.label === "Ungrouped" ? null : option.label) && !o.isHeader && !event.some((e) => e.label === o.label)),
          );
        } else {
          selectedOptions.push(option);
        }
      });
      this.validate();
      this.$emit("input", selectedOptions);
    },
    reset() {
      this.isResetting = true;
      this.$emit("input", []);
    },
  },
};
</script>

<style lang="scss">
:root {
  --vs-border-color: transparent;
}

.form-select {
  .vs__dropdown-toggle {
    border: none;
  }

  .vs__actions {
    display: none;
  }

  .vs__dropdown-menu {
    border: none;
  }
}

.advance-form-select {
  background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e");
  background-position-x: calc(100% - 8px);
  background-position-y: 50%;
  background-repeat: no-repeat;
  background-size: 21px 21px;
}
</style>
